import React, { useContext } from "react";
import PageContainer from "@components/pages/PageContainer";
import OrderCreate from '@components/orders/OrderCreate';
import { MenuContext } from '@stores/MenuContext';

const PgOrderCreate = () => {
  const { activeMenuId, setActiveMenuId } = useContext(MenuContext);
  if (activeMenuId !== 'newOrder') setActiveMenuId('newOrder');

  return (
    <PageContainer title={'Purchase More Credits'}>
      <OrderCreate />
    </PageContainer>
  );
};

export default PgOrderCreate;
